import React from 'react';
import { HeaderBanner } from '@husslehq/api-client-ts';

export type MenuItem =
  | {
      label: string;
      link?: never;
      action: () => void;
      trackingCategory: string;
      trackingLabel: string;
      trackingAction: string;
    }
  | {
      label: string;
      link: string;
      action?: never;
      trackingCategory: string;
      trackingLabel: string;
      trackingAction: string;
    };

export type HeaderContextProps = {
  isAuthenticated: boolean;
  isDropDownOpen: boolean;
  isMobileView: boolean;
  login: () => void;
  logout: () => void;
  menuItems: Array<MenuItem>;
  register: () => void;
  toggleDropDown: () => void;
  walletAmount: number;
  headerBanner?: HeaderBanner;
};

export const HeaderContext = React.createContext<HeaderContextProps>({} as HeaderContextProps);
